import reactBootstrap from "./react/reactBoostrapper";
import { piwikTracker } from "./components/piwikTracker";
import { svgInject } from "./components/svgInject";
import { lazyLoad } from "./components/lazyLoad";
import { classesOnScroll } from "./components/classesOnScroll";
import { navbarBurger } from "./components/navbarBurger";
import { navbarNavigation } from "./components/navbarNavigation";
import { videoController } from "./components/videoController";
import { arrowAnchor } from "./components/arrowAnchor";
import { backToTop } from "./components/backToTop";
import { newsletterForm } from "./components/newsletterForm";
import { parallax } from "./components/parallax";
import { intersectionObserver } from "./components/intersectionObserver";
import { accordion } from "./components/accordion";
import { countdown } from "./components/countdown";
import { tabSelection } from "./components/tabSelection";
import {newsletterAnchor} from "./components/newsletterAnchor";

// swiper
import swiperRaceDetails from "./components/swiper/swiperRaceDetails";
import swiperNewsCards from "./components/swiper/swiperNewsCards";
import swiperIronWorldCards from "./components/swiper/swiperIronWorldCards";
import swiperFactsAndWallOfFame from "./components/swiper/swiperFactsAndWallOfFame";
import swiperTimeline from "./components/swiper/swiperTimeline";
import swiperTimelineProgressive from "./components/swiper/swiperTimelineProgressive";
import swiperSideTitle from "./components/swiper/swiperSideTitle";
import swiperIronDamesStaffCards from "./components/swiper/swiperIronDamesStaffCards";
import swiperMultimedia from "./components/swiper/swiperMultimedia";
import swiperMultimediaList from "./components/swiper/swiperMultimediaList";
import swiperTextVerticalCarousel from "./components/swiper/swiperTextVerticalCarousel";
import swiperSimpleSingleImage from "./components/swiper/swiperSimpleSingleImage";
import swiperDriverGallery from "./components/swiper/swiperDriverGallery";
import swiperRacingSeason from "./components/swiper/swiperRacingSeason";
import swiperChampionshipLineUp from "./components/swiper/swiperChampionshipLineUp";
import swiperChampionshipRaces from "./components/swiper/swiperChampionshipRaces";
import swiperDiscoverOurHqCards from "./components/swiper/swiperDiscoverOurHqCards";
import swiperTabsWithContent from "./components/swiper/swiperTabsWithContent";

let appBootstrap = ($) => {


    // Piwik events
    piwikTracker.init();


    // standard or jquery components
    svgInject.init();
    lazyLoad.init();
    parallax.init();
    classesOnScroll.init();
    intersectionObserver.init();
    navbarBurger.init();
    navbarNavigation.init();
    videoController.init();
    arrowAnchor.init();
    backToTop.init();
    newsletterForm.init();
    accordion.init();
    countdown.init();
    tabSelection.init();
    newsletterAnchor.init();


    // swiper
    swiperRaceDetails.init();
    swiperNewsCards.init();
    swiperIronWorldCards.init();
    swiperFactsAndWallOfFame.init();
    swiperTimeline.init();
    swiperTimelineProgressive.init();
    swiperSideTitle.init();
    swiperIronDamesStaffCards.init();
    swiperMultimedia.init();
    swiperMultimediaList.init();
    swiperTextVerticalCarousel.init();
    swiperSimpleSingleImage.init();
    swiperDriverGallery.init();
    swiperRacingSeason.init();
    swiperChampionshipLineUp.init();
    swiperChampionshipRaces.init();
    swiperDiscoverOurHqCards.init();
    swiperTabsWithContent.init();


    if ($(["data-youtube-video"]).length) {
        import("./components/youtubeVideoPlayer").then(
            ({ youtubeVideoPlayer }) => {
                youtubeVideoPlayer.init();
            }
        );
    }


    // react bootstrap
    reactBootstrap.init();
    window.reactBootstrap = reactBootstrap;
};

export const bootstrapper = {
    init: () => {
        appBootstrap(jQuery);
        return require("../../package.json").version; // return version nr from package.json
    },
};
